import { BUSINESS_TYPE_ACCOUNTANCY_ID, BUSINESS_TYPE_BOOKKEEPER_ID } from '@futrli/shared-services';

const PROVISION_ACCOUNTANCY = 'accountancy-firm';
const PROVISION_BOOKKEEPER = 'bookkeeper';
const PROVISION_BUSINESS = 'business';

export const getProvisionBusinessType = (businessType: string) => {
  if (businessType === BUSINESS_TYPE_ACCOUNTANCY_ID) {
    return PROVISION_ACCOUNTANCY;
  } else if (businessType === BUSINESS_TYPE_BOOKKEEPER_ID) {
    return PROVISION_BOOKKEEPER;
  }

  return PROVISION_BUSINESS;
};
